import { formatNumber } from "accounting"

import { formatCurrency } from "../../Utils/utils"

// How a KPI figure reads outside its animated headline (the comparison line, a chart tooltip):
// money in dollars, a rate in whole percent unless the figure asks for `decimals`, anything else as
// a grouped count.
export const formatKpiValue = ({ prefix, suffix, decimals = 0 }) => {
  if (prefix === "$") return (value) => formatCurrency(value ?? 0, true)
  if (suffix === "%") return (value) => `${formatNumber(value ?? 0, decimals, ",", ".")}%`
  return (value) => formatNumber(value ?? 0, 0, ",", ".")
}
